<template>
  <div class="BookingHistory p-3">
    <v-card>
      <div class="pt-3">
        <v-btn class="mx-3" @click="filter_panel = !filter_panel">
          {{ $t("manage.by_school.group_experiment.history.btn_filter") }}
          <v-icon v-if="!filter_panel">mdi-menu-down</v-icon>
          <v-icon v-if="filter_panel">mdi-menu-up</v-icon>
        </v-btn>
        <v-btn class="mx-3" @click="applyFilter">
          <v-icon>mdi-reload</v-icon>
        </v-btn>
        <v-breadcrumbs :items="breadcrumbLabel('filter')" large></v-breadcrumbs>
      </div>
      <v-expand-transition>
        <div class="mx-3 mb-5"  v-show="filter_panel">
          <v-card>
            <v-row class="justify-center p-3">
              <v-col cols="12">
                <v-select
                  :items="api.schools"
                  item-text="school_id"
                  item-value="school_id"
                  v-model="form.school_id"
                  :label="filterLabel('school_label')"
                  dense
                  :disabled="current.user_level!='ADMIN'"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="api.experiments"
                  :item-text="filterLabel('experiment_set_text')"
                  item-value="experiment_set"
                  v-model="form.selected_experiment"
                  :label="filterLabel('experiment_set_label')"
                  no-data-text="No Experiment Available"
                  dense
                  @change="changeExperimentSet(form.selected_experiment)"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-if="$i18n.locale=='tc'"
                  :items="statuses"
                  item-text="text_chi"
                  item-value="text"
                  v-model="form.status"
                  :label="filterLabel('status_label')"
                  dense
                  :disabled="current.user_level!='ADMIN'"
                ></v-select>
                <v-select
                  v-else
                  :items="statuses"
                  item-text="text"
                  item-value="text"
                  v-model="form.status"
                  :label="filterLabel('status_label')"
                  dense
                  :disabled="current.user_level!='ADMIN'"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  range
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      :label="filterLabel('date_range_label')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="form.dates=[]"
                      dense
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :locale="localeTranslate()"
                    v-model="form.dates"
                    color="green lighten-2"
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="green " @click="menu = false">
                      {{ $t("manage.by_school.group_experiment.history.filter.btn_datepicker_close") }}
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="mr-2"
                  color="primary"
                  @click="applyFilter"
                >
                  {{ $t("manage.by_school.group_experiment.history.filter.btn_apply") }}
                </v-btn>
                <v-btn
                  color="grey lighten-3"
                  @click="resetFilter"
                >
                  {{ $t("manage.by_school.group_experiment.history.filter.btn_reset") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-expand-transition>
      <v-data-table
        dense
        :locale="localeTranslate()"
        :headers="bookSlotLabel('header')"
        :items="api.group_experiment_slots"
        item-key="id"
        :sort-by="['start_date']"
        :sort-desc="[true]"
        multi-sort
        :items-per-page="10"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top color="blue darken-4">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="viewGroupExperimentSlot(item)">
                <v-icon small color="blue darken-4"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.group_experiment.history.btn_view") }}</span>
          </v-tooltip>

          <v-tooltip top color="primary">
            <template v-slot:activator="{ on, attrs }">
              <v-btn disabled icon v-bind="attrs" v-on="on" @click="openUserGroupDialog(item)">
                <v-icon small color="teal"> mdi-account-plus </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.group_experiment.history.btn_assign_group") }}</span>
          </v-tooltip>
          <v-tooltip v-if='item.status!="CANCELLED"' top color="red lighten-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn disabled icon v-bind="attrs" v-on="on" @click="openCancelBookSlotDialog(item)">
                <v-icon small color="red lighten-2"> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("manage.by_school.group_experiment.history.btn_remove") }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-card v-if="slot_view" class="my-3 mb-8">
      <h6 class="p-3 pb-0">{{ $t("manage.by_school.group_experiment.history.view_period.header") }}</h6>
      <v-breadcrumbs :items="breadcrumbLabel('booking')" large></v-breadcrumbs>
      <v-row>
        <v-col sm="12" md="4" class="mx-4">
          <v-card>
            <v-card-title class="body-1">
              <u><v-icon class="pr-2">mdi-information</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.header") }}</u>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                <div class="text-body-2 mt-n4">
                  <v-card-text class="pt-0 text-body-1 font-weight-bold">
                    <div class="text-body-2 px-auto">
                      <table style="border-collapse: collapse;">
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.ref") }}</td>
                          <td class="pl-2">{{ selected_slot.ref }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.experiment_set") }}</td>
                          <td v-if="$i18n.locale=='tc'" class="pl-2">{{ api.group_experiment_info.experiment_set_chi }}</td>
                          <td v-else class="pl-2">{{ api.group_experiment_info.experiment_set }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.start") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.start_datetime }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.end") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.end_datetime }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.status") }}</td>
                          <td v-if="$i18n.locale=='tc'" class="pl-2">{{ api.group_experiment_info.status_chi }}</td>
                          <td v-else class="pl-2">{{ api.group_experiment_info.status }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.create_by") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.create_by }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.create_at") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.create_at }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid lightgray;">
                          <td>{{ $t("manage.by_school.group_experiment.history.view_period.slot_information.table.last_update") }}</td>
                          <td class="pl-2">{{ api.group_experiment_info.update_at }}</td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col sm="12" md="4" class="mx-4">
          <v-card>
            <v-card-title class="body-1">
              <u><v-icon class="pr-2">mdi-cog</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.header") }}</u>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                <div v-if="api.group_experiment_info.config_exist==true" class="text-body-2 mt-n4">
                  <v-card-text class="pt-0 text-body-1 font-weight-bold">
                    <div class="text-body-2 px-auto">
                      <table style="border-collapse: collapse;">
                        <tr v-for="(value, key) in api.group_experiment_info.config" :key="key" style="border-bottom: 1px solid lightgray;">
                          <td>{{ key }}:</td>
                          <td class="pl-2">{{ value }}</td>
                        </tr>
                      </table>
                    </div>
                  </v-card-text>
                </div>
                <div v-else>
                  {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.no_record") }}
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="openEditConfigDialog()">{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.btn_edit") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>        
        <v-col v-if="0" sm="12" md="3" class="mx-4">
          <v-card>
            <v-card-title class="body-1">
              <u><v-icon class="pr-2">mdi-image-multiple</v-icon>{{ $t("manage.by_school.group_experiment.history.view_period.snapshot.header") }}</u>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                <div v-if="api.group_experiment_info.photo_exist==true" class="text-body-2 mt-n4">
                  <v-card-text class="pt-0 text-body-1 font-weight-bold">
                    <div class="text-body-2 px-auto">
                      <div v-for="(item, i) in api.group_experiment_info.photos" :key="i">
                          <a :href="item.src" target="_BLANK"><v-icon class="p-1" color="primary" small>mdi-image-outline</v-icon>{{ item.filename }}</a>
                        </div>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn @click="downloadGroupExperimentSnapshots()">{{ $t("manage.by_school.group_experiment.history.view_period.snapshot.btn_download_all") }}</v-btn>
                  </v-card-actions>
                </div>
                <div v-else>
                  {{ $t("manage.by_school.group_experiment.history.view_period.snapshot.no_snapshot") }}
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog
      v-model="userGroupDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.group_experiment.history.assign_group.header") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ userGroupItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ userGroupItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ userGroupItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ userGroupItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.date") }}</th>
              <td>{{ userGroupItem.start_date }} - {{ userGroupItem.end_date }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.open_hour") }}</th>
              <td>{{ userGroupItem.open_time }} - {{ userGroupItem.close_time }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.user_group") }}</th>
              <td>{{ userGroupItem.groups }}</td>
            </tr>
          </table>
          <hr>
          <v-checkbox
                v-model="assignCheckbox"
                hide-details
                class="shrink mr-2 mt-0"
              ></v-checkbox>
              <v-select
                multiple
                chips
                :items="assignedGroups"
                item-text="user_group"
                item-value="user_group"
                v-model="editGroups"
                :label="assignGroupLabel('assign')"
                :disabled="!assignCheckbox"
              ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeUserGroupDialog()"
          >
            Discard
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="assignGroupsToBookSlot(userGroupItem)"
            :disabled="!assignCheckbox"
          >
            Set
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="lockDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_lock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.date") }}</th>
              <td>{{ lockUnlockItem.start_date }} - {{ lockUnlockItem.end_date }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.open_hour") }}</th>
              <td>{{ lockUnlockItem.open_time }} - {{ lockUnlockItem.close_time }}</td>
            </tr>
          </table>
          <v-divider></v-divider>
          <v-checkbox
            v-model="holdCheckbox"
            :label="lockBookSlotLabel('suspendCheckbox')"
          ></v-checkbox>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="lockDialog = false; lockUnlockItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="lockBookSlot(lockUnlockItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unlockDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.book_slot.header_unlock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.date") }}</th>
              <td>{{ lockUnlockItem.start_date }} - {{ lockUnlockItem.end_date }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.open_hour") }}</th>
              <td>{{ lockUnlockItem.open_time }} - {{ lockUnlockItem.close_time }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="unlockDialog = false; lockUnlockItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unlockBookSlot(lockUnlockItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelBookSlotDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.book_slot.header_cancel") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookSlotItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookSlotItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookSlotItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookSlotItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.date") }}</th>
              <td>{{ cancelBookSlotItem.start_date }} - {{ cancelBookSlotItem.end_date }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.open_hour") }}</th>
              <td>{{ cancelBookSlotItem.open_time }} - {{ cancelBookSlotItem.close_time }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="cancelBookSlotDialog = false; cancelBookSlotItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="cancelBookSlot(cancelBookSlotItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="lockBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_lock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ lockUnlockBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ lockUnlockBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="lockBookingDialog = false; lockUnlockBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="lockBooking(lockUnlockBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unlockBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_unlock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ lockUnlockBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ lockUnlockBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="unlockBookingDialog = false; lockUnlockBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unlockBooking(lockUnlockBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="maintenanceDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_set_maintenance") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ maintenanceItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ maintenanceItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ maintenanceItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ maintenanceItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ maintenanceItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ maintenanceItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="maintenanceDialog = false; maintenanceItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="setMaintenanceBooking(maintenanceItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unsetMaintenanceDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_unset_maintenance") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ maintenanceItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ maintenanceItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ maintenanceItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ maintenanceItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ maintenanceItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ maintenanceItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="unsetMaintenanceDialog = false; maintenanceItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unsetMaintenanceBooking(maintenanceItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>    
    <v-dialog
      v-model="cancelBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_remove") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ cancelBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ cancelBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="cancelBookingDialog = false; cancelBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            text
            @click="cancelBooking(cancelBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="undoCancelBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_restore") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookingItem.ref }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ cancelBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ cancelBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="undoCancelBookingDialog = false; cancelBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="undoCancelBooking(cancelBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="editConfigDialog"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.header") }}
        </v-card-title>
        <v-card-text>
          <table style="border-collapse: collapse;">
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.ref") }}</th>
              <td>{{ api.group_experiment_info.ref }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.school") }}</th>
              <td>{{ api.group_experiment_info.school }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ api.group_experiment_info.experiment_set }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.start") }}</th>
              <td>{{ api.group_experiment_info.start_datetime }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("booking.dialog.end") }}</th>
              <td>{{ api.group_experiment_info.end_datetime }}</td>
            </tr>
            <tr style="border-bottom: 1px solid lightgray;">
              <th class='pr-2' style="vertical-align: top;">{{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.recent_display") }}</th>
              <td>{{ api.group_experiment_info.config }}</td>
            </tr>
          </table>
          <v-row class="mt-3">
            <v-textarea
              filled
              :label="editSettingLabel('textarea')"
              v-model="editConfigForm.value"
            ></v-textarea>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeEditConfigDialog">
            {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_discard") }}
          </v-btn>
          <v-btn color="green darken-1" text @click="editGroupExperimentConfig">
            {{ $t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  
import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);

import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);


import { api_experiment } from "@/services/iot/api_experiment";
const apiExperiment = new api_experiment(process.env.VUE_APP_BASE_URL);


export default {
  name: "GroupExperimentHistory",
  data: function () {
    return {
      menu: false,
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api: {
        schools: [],
        experiment_sets: [],
        experiments: [],
        group_experiment_slots: [],
        group_experiment_info: [],
        bookings: [],
        status: "ACTIVE",
      },
      form: {
        selected_experiment: "All",
        start_from: "09:00",
        end_at: "18:00",
        duration: "55",
        prepare: "5",
        status: "ACTIVE",
        school_id: "",
        dates: [],
        experiment: "All",
        equipment_id: "All",
      },
      editConfigForm: {
        value: "",
      },
      viewItem: "",
      assignCheckbox: false,
      userGroupItem: {},
      assignedGroups: [],
      editGroups: [],
      lockUnlockItem: {},
      lockUnlockBookingItem: {},
      maintenanceItem: {},
      cancelBookSlotItem: {},
      cancelBookingItem: {},      
      holdCheckbox:true,
      dialog: false,
      editConfigDialog: false,
      userGroupDialog: false,
      unlockDialog: false,
      lockDialog:false,
      lockBookingDialog: false,
      unlockBookingDialog: false,
      maintenanceDialog: false,
      unsetMaintenanceDialog:false,
      cancelBookSlotDialog: false,
      cancelBookingDialog: false,
      undoCancelBookingDialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      school_id: "",
      experiment: "",
      equipment_id: "",
      school_valid: false,
      role: null,
      drawer: true,
      mini: true,
      slot_view: false,
      booking_breadcrumbs: [],
      booking_breadcrumbs_chi: [],
      filter_breadcrumbs: [{ text: 'Filter'},],
      filter_breadcrumbs_chi: [{ text: '篩選'},],
      filter_panel: false,
      selected_slot: null,
      statuses: [
        { text: "ACTIVE", text_chi: "有效", value: "ACTIVE" },
        { text: "CANCELLED", text_chi: "已移除", value: "CANCELLED" },
        { text: "HOLD", text_chi: "暫停", value: "HOLD" },
      ],
      headers: [
        { text: "Ref", value: "ref" },
        { text: "School", value: "school" },
        { text: "Experiment Set", value: "experiment_set" },
        { text: "Start Date/time", value: "start_datetime" },
        { text: "End Date/time", value: "end_datetime" },
        { text: "Groups", value: "groups" },
        { text: "Status", value: "status" },
        { text: "Create by", value: "create_by" },
        { text: "Create at", value: "create_at" },
        { text: "Update at", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headers_chi: [
        { text: "參考編號", value: "ref" },
        { text: "學校ID", value: "school" },
        { text: "實驗組", value: "experiment_set_chi" },
        { text: "開始日期/時間", value: "start_datetime" },
        { text: "結束日期/時間", value: "end_datetime" },
        { text: "用戶組別", value: "groups" },
        { text: "狀態", value: "status_chi" },
        { text: "創建者", value: "create_by" },
        { text: "創建於", value: "create_at" },
        { text: "最後更新", value: "update_at" },
        { text: "操作", value: "actions", sortable: false },
      ],
      booking_headers: [
        { text: "Session Start", value: "start_at" },
        { text: "Session End", value: "end_at" },
        { text: "Status", value: "status" },
        { text: "Has Entered", value: "has_entered" },
        { text: "Username", value: "username" },
        { text: "Update at", value: "update_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      booking_headers_chi: [
        { text: "時段開始", value: "start_at" },
        { text: "時段結束", value: "end_at" },
        { text: "狀態", value: "status_chi" },
        { text: "已進入", value: "has_entered" },
        { text: "用戶名稱", value: "username" },
        { text: "最後更新", value: "update_at" },
        { text: "操作", value: "actions", sortable: false },
      ],
    };
  },
  mounted: function () {
    var self = this;
    self.current.school_id = self.$route.params.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
//    if(self.current.user_level != "ADMIN" ){
      self.api.schools = [self.current.school_id];
      self.form.school_id = self.current.school_id;
//    }
    self.filter_breadcrumbs = [
      { text: 'School: ' + self.current.school_id },
      { text: 'Experiment Set: All' },
      { text: 'Status: ACTIVE' },
      { text: 'Date: All' }
    ];
    self.filter_breadcrumbs_chi = [
      { text: '學校: ' + self.current.school_id },
      { text: '實驗組: 全部' },
      { text: '狀態: 有效' },
      { text: '日期: 全部' }
    ];
    self.getSchoolFromSchoolList();
    self.getSchoolGroupExperiment();
    self.getSchoolUserGroups();
    apiManagement
    .getGroupExperimentSlotsBySchool(self.current.school_id, 'All', 'All', null, null, self.form.status)
    .then((response) => {
      self.api.group_experiment_slots = response.group_experiment_slots;
    });
  },  
  computed: {
    dateRangeText() {
      return this.form.dates.join(" ~ ");
    },
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    getSchoolGroupExperiment() {
      var self = this;
      apiManagement.getSchoolGroupExperiment(self.current.school_id).then((response) => {
        self.api.experiments = [{'experiment_set':'All', 'experiment_set_chi':'全部'}]
        self.api.experiments = self.api.experiments.concat(response.experiments);
      });
    },
    getSchoolFromSchoolList() {
      var self = this;
      apiManagement.getSchoolFromSchoolList(self.current.school_id).then((response) => {
        if (response.status == "success") {
          self.school_valid = true;
        } else {
          self.school_valid = false;
          alert(response.error);
        }
      });
    },
    changeExperimentSet(experiment_set){      
      var self = this;
      if(experiment_set=="All"){
        experiment_set = "All - All";
      }
      let split = experiment_set.split(" - ");
      self.form.experiment = split[0];
      self.form.equipment_id = split[1];
    },
    editSettingLabel(label){
      var self = this;
      if(label == 'textarea') return self.$t("manage.by_school.group_experiment.history.view_period.experiment_setting_display.edit.text_note");
    },
    lockBookSlotLabel(label){
      var self = this;
      if(label == 'suspendCheckbox') return self.$t("booking.dialog.book_slot.suspend_checkbox");
    },
    assignGroupLabel(label){
      var self = this;
      if(label == 'assign') return self.$t("manage.by_school.group_experiment.history.assign_group.assign_group");
    },
    bookSlotLabel(label) {
      var self = this;
      if(label=='header') {
        if(self.$i18n.locale=='tc') return self.headers_chi;
        else return self.headers;
      }
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.history.filter.experiment_set");
      else if(label=='experiment_set_text') {
        if(self.$i18n.locale=='tc') return 'experiment_set_chi';
        else return 'experiment_set';
      }
    },
    bookingLabel(label) {
      var self = this;
      if(label=='header') {
        if(self.$i18n.locale=='tc') return self.booking_headers_chi;
        else return self.booking_headers;
      }
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.history.filter.experiment_set");
      else if(label=='experiment_set_text') {
        if(self.$i18n.locale=='tc') return 'experiment_set_chi';
        else return 'experiment_set';
      }
    },
    breadcrumbLabel(label){
      var self = this;
      if(label=='filter') {
        if(self.$i18n.locale=='tc') return self.filter_breadcrumbs_chi;
        else return self.filter_breadcrumbs;
      }
      else if(label=='booking') {
        if(self.$i18n.locale=='tc') return self.booking_breadcrumbs_chi;
        else return self.booking_breadcrumbs;
      }
    },
    filterLabel(label){
      var self = this;
      if(label=='school_label') return self.$t("manage.by_school.group_experiment.school");
      else if(label=='experiment_set_label') return self.$t("manage.by_school.group_experiment.history.filter.experiment_set");
      else if(label=='experiment_set_text') {
        if(self.$i18n.locale=='tc') return 'experiment_set_chi';
        else return 'experiment_set';
      }
      else if(label=='date_range_label') return self.$t("manage.by_school.group_experiment.history.filter.date_range");
      else if(label=='status_label') return self.$t("manage.by_school.group_experiment.history.filter.status");
    },
    applyFilter(){
      var self = this;
      if(self.isValid()){
        apiManagement
          .getGroupExperimentSlotsBySchool(self.form.school_id, self.form.experiment, self.form.equipment_id, self.form.dates[0], self.form.dates[1], self.form.status)
          .then((response) => {
            self.api.group_experiment_slots = response.group_experiment_slots;
            let s_date = "All";
            if(self.form.dates[0]!=undefined && self.form.dates[1]!=undefined) {
              s_date = self.form.dates[0] + " ~ " + self.form.dates[1];
            }
            self.filter_breadcrumbs = [
              { text: 'School: ' + self.current.school_id },
              { text: 'Experiment: ' + self.form.selected_experiment },
              { text: 'Status: ' + self.form.status },
              { text: 'Date: ' + s_date }
            ];
            self.filter_panel = false;
          });
      }
    },
    resetFilter(){
      var self = this;
      self.form.experiment = "All";
      self.form.equipment_id = "All";
      self.form.dates = [];
      self.form.selected_experiment = "All";
      apiManagement
        .getGroupExperimentSlotsBySchool(self.form.school_id, self.form.experiment, self.form.equipment_id, self.form.dates[0], self.form.dates[1], self.form.status)
        .then((response) => {
          self.api.group_experiment_slots = response.group_experiment_slots;
          self.filter_breadcrumbs = [
            { text: 'School: ' + self.current.school_id },
            { text: 'Experiment: All' },
            { text: 'Date: All' }
          ];
          self.filter_breadcrumbs_chi = [
            { text: '學校: ' + self.current.school_id },
            { text: '實驗組: 全部' },
            { text: '日期: 全部' }
          ];
          self.filter_panel = false;
        });
    },
    viewGroupExperimentSlot(item) {
      var self = this;
      self.viewItem = item;
      apiManagement
        .getGroupExperimentSlotInfo(self.form.school_id, item.ref)
        .then((response) => {
          self.api.group_experiment_info = response.group_experiment_info;
          self.slot_view = true;
          self.booking_breadcrumbs = [
            { text: 'School: ' + item.school },
            { text: 'Experiment Set: ' + item.experiment + ' - ' + item.equipment_id},
            { text: "Ref: " + item.ref },
          ];
          self.booking_breadcrumbs_chi = [
            { text: '學校: ' + item.school },
            { text: '實驗組: ' + item.experiment_chi + ' - ' + item.equipment_id_chi },
            { text: "參考編號: " + item.ref },
          ];
          self.selected_slot = item;
        });
    },
    assignGroupsToBookSlot(item){
      var self = this;
      
      apiManagement.assignGroupsToBookSlot(item.school,self.editGroups,item.ref)
      .then((response) => {
        if(response.status == "success"){          
          self.applyFilter();
          self.$store.commit("showSnackBar", "Updated user groups to booking ref: " + item.ref);
          self.closeUserGroupDialog();
          //self.getSchoolBookSlots();
        }
        else {
          alert(response.message);
        }
      });
    },
    lockBookSlot(item, hold) {
      var self = this;
      apiManagement
        .lockBookSlot(self.current.school_id, item.ref, self.holdCheckbox)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, item.ref)
            .then((response) => {
              self.lockUnlockItem = {};
              self.lockDialog = false;
              self.holdCheckbox = true;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: item.school },
                { text: item.experiment },
                { text: item.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: item.school },
                { text: item.experiment_chi },
                { text: item.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unlockBookSlot(item) {
      var self = this;
      apiManagement
        .unlockBookSlot(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, item.ref)
            .then((response) => {
              self.lockUnlockItem = {};
              self.unlockDialog = false;
              self.holdCheckbox = true;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: item.school },
                { text: item.experiment },
                { text: item.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: item.school },
                { text: item.experiment_chi },
                { text: item.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    lockBooking(item) {
      var self = this;
      apiManagement
        .lockBooking(self.current.school_id, item.ref, item.status)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.lockBookingDialog = false;
              self.lockUnlockBookingItem= {}
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unlockBooking(item) {
      var self = this;
      apiManagement
        .unlockBooking(self.current.school_id, item.ref, item.status)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.unlockBookingDialog = false;
              self.lockUnlockBookingItem= {}
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    setMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .setMaintenanceBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.maintenanceItem = {};
              self.maintenanceDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    unsetMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .unsetMaintenanceBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.maintenanceItem = {};
              self.unsetMaintenanceDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    cancelBookSlot(item) {
      var self = this;
      apiManagement
        .cancelBookSlot(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, item.ref)
            .then((response) => {
              self.cancelBookSlotItem = {};
              self.cancelBookSlotDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + item.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + item.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    cancelBooking(item) {
      var self = this;
      apiManagement
        .cancelBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.cancelBookingItem = {};
              self.cancelBookingDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    undoCancelBooking(item) {
      var self = this;
      apiManagement
        .undoCancelBooking(self.current.school_id, item.ref)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getGroupExperimentSlotsBySchool();
            apiManagement
            .getSchoolBookings(self.current.school_id, self.selected_slot.ref)
            .then((response) => {
              self.cancelBookingItem = {};
              self.undoCancelBookingDialog = false;
              self.api.bookings = response.bookings;
              self.slot_view = true;
              self.booking_breadcrumbs = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment },
                { text: self.selected_slot.equipment_id },
                { text: "Ref: " + self.selected_slot.ref },
              ];
              self.booking_breadcrumbs_chi = [
                { text: self.selected_slot.school },
                { text: self.selected_slot.experiment_chi },
                { text: self.selected_slot.equipment_id_chi },
                { text: "參考編號: " + self.selected_slot.ref },
              ];
            });
          } else {
            alert(response.message);
            self.slot_view = false;
          }
        });
    },
    createBookSlots: function () {
      var self = this;     
//      if (self.isValid()) {
      apiService.createBookSlots(
          self.form.school,
          self.form.experiment,
          self.form.equipment_id,
          self.form.dates[0],
          self.form.dates[1],
          self.form.start_from,
          self.form.end_at,
          self.form.duration,
          self.form.prepare
        )
        .then((response) => {
          if (response.status == "success") {
            alert("success");
//            alert("Assigned " + response.count + " slots successfully");
          } else {
            alert(response.message);
          }
        });
//      }
    },
    isValid: function () {
      var self = this;
      if (self.form.dates[0] != undefined && self.form.dates[1] == undefined) {
        alert("Missing end date");
        return false;
      }
      if (self.form.dates[0] > self.form.dates[1]) {
        alert("End date should be larger than Start date");
        return false;
      }
      return true;
    },
    back() {
      var self = this;
      self.$router.push("/school/experiment_list/" + self.current.school_id);
    },
    getSchoolUserGroups(){
      var self = this;
      apiManagement.getSchoolUserGroups(self.current.school_id)
      .then((response) => {
          self.api.groups = response.groups;
      });
    },
    openUserGroupDialog(item){
      var self = this;
      self.userGroupDialog = true;
      self.userGroupItem = item;
      self.assignedGroups = self.api.groups;
      if(item.groups==""){
        self.editGroups = [];
      }
      else {
        self.editGroups = item.groups.split(", ");
      }
    },
    closeUserGroupDialog(){
      var self = this;
      self.userGroupDialog = false;
      self.userGroupItem = {};
      self.assignCheckbox = false;
      self.editGroups = [];
    },
    openCancelBookSlotDialog(item){
      var self = this;
      self.cancelBookSlotDialog = true;
      self.cancelBookSlotItem = item;
    },
    openCancelBookingDialog(item){
      var self = this;
      self.cancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
    openUndoCancelBookingDialog(item){
      var self = this;
      self.undoCancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
    openEditConfigDialog(){
      var self = this;
      self.editConfigDialog = true;
      if(self.api.group_experiment_info.config_exist){
        self.editConfigForm.value = JSON.stringify(self.api.group_experiment_info.config);
      console.log(self.editConfigForm.value);
      }
      else {

      console.log(self.editConfigForm.value);
      }
    },
    closeEditConfigDialog(){
      var self = this;
      self.editConfigDialog = false;
      self.editConfigForm.value = "";
    },    
    editGroupExperimentConfig: function () {
      var self = this;
      apiManagement.editGroupExperimentConfig(self.api.group_experiment_info.school, self.api.group_experiment_info.experiment, self.api.group_experiment_info.equipment_id, self.api.group_experiment_info.ref, self.editConfigForm.value)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.closeEditConfigDialog();
            self.viewGroupExperimentSlot(self.viewItem);
          } else {
            alert(response.message);
          }
        });
    },
    downloadGroupExperimentSnapshots(){
      var self = this;
      
      apiExperiment.downloadGroupExperimentSnapshots(self.viewItem.school, self.viewItem.experiment, self.viewItem.equipment_id, self.viewItem.ref)
        .then((response) => {
          if(response.status == "success"){
            window.open(process.env.VUE_APP_BASE_URL + "/api/iot/experiment/storage/" + response.downloadPath);
          }
          else {
            alert(response.message);
          }
        });
    }
  },
  watch: {},
};
</script>

<style scoped lang="scss">
</style>